import { render } from "./Participants.vue?vue&type=template&id=8dd985b4"
import script from "./Participants.vue?vue&type=script&lang=js"
export * from "./Participants.vue?vue&type=script&lang=js"
script.render = render

export default script